import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { Slot } from '@ils/slots/db/slot.js';
import { Names } from '@ils/static/names.js';
import { DateTime } from 'luxon';

@Entity()
export class ExamSlotGroup extends AdornisEntity {
  public static override _class = Names.ExamSlotGroup._class;
  @Field(type => DateTime)
  public startTime!: DateTime;
  @Field(type => DateTime)
  public endTime!: DateTime;
  @Field(type => [Slot])
  public slots!: Slot[];
}
